import React, {useEffect, useRef, useState} from 'react';

import {Line} from "../global/Line";
import {Button} from "../global/Button";

import {GifVideo} from "../global/GifVideo";

import Typed from "typed.js";
import {Numbers} from "../global/Numbers";

export const Intro = ({data = {}, stats = []}) => {


  const [lineMob, setLineMob] = useState(null);
  const [lineDesc, setLineDesc] = useState(null);

  const labelRef = useRef(null);

  const textBlock = useRef(null);

  const typedOptions = {
    showCursor:false,
    typeSpeed: 30,
  };
  let typed = [
    {
      text : data.titlePart1,
      ref : useRef(null),
      typed : useRef(null)
    },
    {
      text : data.titlePart2,
      ref : useRef(null),
      typed : useRef(null)
    },
    {
      text : data.titlePart3,
      ref : useRef(null),
      typed : useRef(null)
    },
    {
      text : data.titlePart4,
      ref : useRef(null),
      suptext : useRef(null),
      typed : useRef(null)
    },
  ];
  const LineXMob = () =>{
    return <Line start={typed[3].suptext} end={labelRef} startAnchor="right" endAnchor="left" color={"#DEFF1A"}
                 animateDrawing={0.4}
                 classes="d-lg-none d-none d-md-block"/>;
  };
  const LineXDesc = () =>{
    return <Line start={typed[3].ref} end={labelRef} color={"#DEFF1A"} classes="d-none d-lg-block" animateDrawing={0.4}/>;
  };
  //Typed
  useEffect(() => {
    let nextWordDelay = 0;
    typed.forEach( (item, index) => {
      if(index !== 0){
        nextWordDelay += typed[index - 1].text.length * typedOptions.typeSpeed;
      }

      item.typed.current = new Typed(item.ref.current, {
        ...typedOptions,
        startDelay : nextWordDelay,
        strings: [
          item.text
        ],
        preStringTyped: (arrayPos, self) => {
          self.el.classList.remove('opacity-0')
          if (item.suptext){
            item.suptext.current.classList.remove('opacity-0')
          }
        },
        onComplete: (self) => {
          if(index === typed.length - 1){
            setLineMob(<LineXMob />);
            setLineDesc(<LineXDesc />);

            textBlock.current.classList.remove('opacity-0')
          }
        },
      });
    })
    return () => {
      // Make sure to destroy Typed instance during cleanup
      // to prevent memory leaks
      typed.forEach( (item, index) => {
        item.typed.current.destroy();
      });
    }
  }, []);


  return (
    <section className="pt-14-rem pb-lg-16 pb-md-11  pb-11 zg-build-intro intro">
      <div className="container">
        <div className="row">
          <div className="col">
            <h1 className="h2 mb-lg-5 mb-md-7 mb-6 d-inline-flex flex-wrap align-items-start letter-spacing-6">
              <span
                className="d-inline-block bg-orange text-black mb-1 mb-md-2 py-md-2 px-md-3 p-1 me-1 me-md-2 opacity-0" ref={typed[0].ref}></span>
              <span
                className="d-inline-block bg-white text-black mb-1 mb-md-2 py-md-2 px-md-3 p-1 me-1 me-md-2 opacity-0" ref={typed[1].ref}></span>
              <span
                className="d-inline-block bg-white text-black mb-1 mb-md-2 py-md-2 px-md-3 p-1 me-1 me-md-2 opacity-0" ref={typed[2].ref}></span>
              <div className="d-flex flex-wrap align-items-start">
                <span
                  className="d-inline-block bg-yellow text-black mb-1 mb-md-2 py-md-2 px-md-3 p-1 me-1 me-md-2 opacity-0"
                  ref={typed[3].ref}></span>
                <span className="zg-label letter-spacing-4 text-black bg-yellow opacity-0" ref={typed[3].suptext}>{data.suptext1}</span>
              </div>
            </h1>
          </div>
        </div>
        <div className="opacity-0 transition-opacity" ref={textBlock}>
          <div className="row">
            <div className="col-lg-2 col-md-6 col-6 offset-md-5 offset-lg-1 order-lg-0 order-md-3 mt-md-6 mt-lg-0">
              {data.link && data.link.url && (
                <Button
                  title={data.link.title}
                  url={data.link.url}
                  classes="btn-lg"
                  external={data.link.target === '_blank'}
                />
              )}
            </div>
            <div className="col-lg-5 col-md-5 col-6  order-lg-1 order-md-0">
              <GifVideo fileName="RSK_Build_Animated_Lime_Black_compressed" classes="mt-lg-n6 mt-md-n4 mt-n6 zg-build-intro__img" />
            </div>
            <div className="col-lg-3 col-md-6 align-self-md-end align-self-lg-auto order-lg-2 order-md-2 mt-6 mt-md-0">
              <div className='d-flex align-items-start'>
                <span className="zg-label text-black bg-yellow me-2" ref={labelRef}>{data.number}</span>
                <p className="subtitle-md mb-0">{data.text}</p>
              </div>
            </div>
          </div>

          <Numbers stats={stats} color={'orange'} />

        </div>
        {lineMob}
        {lineDesc}


      </div>
    </section>
  )
}
